/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalOrganizationTimelineDto } from "../models/AjaxResponseOfListOfOperationalOrganizationTimelineDto";
import type { AjaxResponseOfOperationalOrganizationTimelineDto } from "../models/AjaxResponseOfOperationalOrganizationTimelineDto";
import type { CreateOperationalOrganizationTimelineInput } from "../models/CreateOperationalOrganizationTimelineInput";
import type { UpdateOperationalOrganizationTimelineInput } from "../models/UpdateOperationalOrganizationTimelineInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalOrganizationTimelineAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalOrganizationTimelineDto Success
   * @throws ApiError
   */
  public getAll({
    organizationId,
    dateFrom,
    dateTo,
    isHighlighted,
  }: {
    organizationId: number;
    dateFrom?: string;
    dateTo?: string;
    isHighlighted?: boolean;
  }): CancelablePromise<AjaxResponseOfListOfOperationalOrganizationTimelineDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/timeline",
      path: {
        organizationId: organizationId,
      },
      query: {
        dateFrom: dateFrom,
        dateTo: dateTo,
        isHighlighted: isHighlighted,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationTimelineDto Success
   * @throws ApiError
   */
  public create({
    organizationId,
    requestBody,
  }: {
    organizationId: number;
    requestBody?: CreateOperationalOrganizationTimelineInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationTimelineDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/timeline",
      path: {
        organizationId: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    organizationId,
    timelineId,
  }: {
    organizationId: number;
    timelineId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/timeline/{timelineId}",
      path: {
        organizationId: organizationId,
        timelineId: timelineId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalOrganizationTimelineDto Success
   * @throws ApiError
   */
  public update({
    organizationId,
    timelineId,
    requestBody,
  }: {
    organizationId: number;
    timelineId: number;
    requestBody?: UpdateOperationalOrganizationTimelineInput;
  }): CancelablePromise<AjaxResponseOfOperationalOrganizationTimelineDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/organizations/{organizationId}/timeline/{timelineId}",
      path: {
        organizationId: organizationId,
        timelineId: timelineId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
